"use client";

import Link from "next/link";
import { Box, Card, CardContent, Typography, IconButton, Skeleton, CircularProgress } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddToCart from "./add-to-cart";
import DiscountChip from "../discount-chip";
import ProductPrice from "../product-price";
import { useState } from "react";
import { keyframes } from "@mui/system";

const scrollText = keyframes`
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
`;

export default function ProductCardCarrousel({
  product,
  showAddButton = true,
  showDeleteFavouriteButton = false,
  onChange = null,
  onDelete = null,
}) {
  const isLoading = !product;

  if (isLoading) {
    return (
      <Box px={1} sx={{ minWidth: 180 }}>
        <Card
          sx={{
            borderRadius: "20px",
            overflow: "hidden",
            position: "relative",
            backgroundColor: "white",
          }}
          elevation={0}
        >
          <Skeleton variant="rectangular" width="100%" height={180} />

          <CardContent sx={{ p: 1 }}>
            <Skeleton variant="text" width="80%" />
            <Skeleton variant="text" width="50%" />
          </CardContent>
        </Card>
      </Box>
    );
  }
  const { price, photo, id, discount_price, name } = product;
  const [deleting, setDeleting] = useState(false);

  return (
    <Box key={id} px={1} sx={{ minWidth: 180 }}>
      <Card
        sx={{
          borderRadius: "20px",
          overflow: "hidden",
          position: "relative",
          backgroundColor: "white",
        }}
        elevation={0}
      >
        <Box sx={{ position: "relative" }}>
          <Link prefetch={false} href={`/products/${id}`} style={{ display: "block" }}>
            <img
              src={photo}
              alt={name}
              style={{
                width: "100%",
                height: "140px",
                objectFit: "contain",
                backgroundColor: "white",
              }}
            />
            {discount_price > 0 && (
              <DiscountChip discount={100 - (discount_price / price) * 100} />
            )}
          </Link>

          {showAddButton && (
            <Box
              size="small"
              sx={{marginTop: 1}}
            >
              <AddToCart product={product} />
            </Box>
          )}

          {showDeleteFavouriteButton && (
            <IconButton
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                bgcolor: "white",
                boxShadow: 1,
                "&:hover": { bgcolor: "white" },
              }}
              size="small"
              onClick={async () => {
                try {
                  setDeleting(true);
                  await onDelete?.(id);
                } finally {
                  setDeleting(false);
                }
              }}
            >
              {deleting ? <CircularProgress size={20} /> : <DeleteIcon color="error" fontSize="small" />}
            </IconButton>
          )}

        </Box>

        <CardContent sx={{ p: 1 }}>
          <Box
            sx={{
              overflow: "hidden",
              position: "relative",
              height: 24,
            }}
          >
            <Typography
              variant="body2"
              sx={{
                fontSize: 14,
                fontWeight: 500,
                whiteSpace: "nowrap",
                overflow: "hidden",
                display: "inline-block",
                animation: `${scrollText} 6s linear infinite`,
              }}
            >
              {name}
            </Typography>
          </Box>

          <ProductPrice
            discount={discount_price === 0 ? 0 : ((price - discount_price) / price) * 100}
            price={price}
          />
        </CardContent>



      </Card>
    </Box>
  );
}
